import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown } from 'react-icons/fa';
import clsx from 'clsx';
import Popover from '../Popover';

const InfoDropdownPopover = ({
  onOpen,
  onClose,
  dropdownTextPlaceholder,
  children,
  alignClass,
  rotate,
  fontSize,
  popoverAlignClass,
  className,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOpen = () => {
    setIsPopoverOpen(true);
    onOpen();
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
    onClose();
  };

  // TODO: refactor to use dropdown component
  return (
    <div className={clsx('relative w-full', className)}>
      <div
        className={`${fontSize || 'text-xs'} text-theme cursor-pointer z-10 flex ${alignClass} items-center`}
        onClick={handleOpen}
        role="button"
        onKeyDown={handleOpen}
        tabIndex="-1"
      >
        {dropdownTextPlaceholder}
        {' '}
        <FaChevronDown className={`inline-block pl-1 text-theme transform ${rotate}`} />
      </div>
      <Popover open={isPopoverOpen} close={handleClose} widthClass="sm:min-w-80 min-w-56" marginClass="mt-1" align={popoverAlignClass}>
        {children}
      </Popover>
    </div>
  );
};

InfoDropdownPopover.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  dropdownTextPlaceholder: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  alignClass: PropTypes.string,
  rotate: PropTypes.string,
  fontSize: PropTypes.string,
  popoverAlignClass: PropTypes.string,
  className: PropTypes.string,
};

InfoDropdownPopover.defaultProps = {
  children: undefined,
  onOpen: () => {},
  onClose: () => {},
  alignClass: 'justify-end',
  rotate: '',
  fontSize: '',
  popoverAlignClass: undefined,
  className: '',
};

export default memo(InfoDropdownPopover);
